enum Route {
  home = 'home',
  step1 = 'income',
  step2 = 'household',
  step3 = 'day2day',
  step4 = 'personal',
  step5 = 'debts-and-loans',
  step6 = 'protection',
  step7 = 'savings',
  results = 'results',
  email = 'email',
  send_email = 'send_email',
  email_done = 'email_done',
}

function prevPage (r: Route) {
  switch (r) {
  case Route.step1: return '/'
  case Route.step2: return Route.step1
  case Route.step3: return Route.step2
  case Route.step4: return Route.step3
  case Route.step5: return Route.step4
  case Route.step6: return Route.step5
  case Route.step7: return Route.step6
  case Route.results: return Route.step7
  case Route.email: return Route.results
  default:
  case Route.home:
    return null
  }
}


function nextPage (r: Route) {
  switch (r) {
  case Route.home: return Route.step1
  case Route.step1: return Route.step2
  case Route.step2: return Route.step3
  case Route.step3: return Route.step4
  case Route.step4: return Route.step5
  case Route.step5: return Route.step6
  case Route.step6: return Route.step7
  case Route.step7: return Route.results
  case Route.results: return Route.email
  case Route.email:
    return Route.send_email
  case Route.send_email:
  case Route.email_done:
    return null
  default:
  case Route.home:
    return Route.step1
  }
}

export { nextPage, prevPage }
export default Route
